<template>
  <div class="page_box">
    
    <div class="page_option_box ">
      <div class="option_box ">
      </div>
      <div class="search_box ">
        <el-input
              placeholder="请输入任务称"
              size="mini"
              class="textInput"
              v-model.trim="requestData.mealTaskName"
            ></el-input>
            &nbsp;&nbsp;
            <el-button
              type="primary"
              size="mini"
              plain
              icon="el-icon-search"
              @click="searchData()"
              >搜索</el-button
            >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
          <el-table
            :data="responseData.list"
            height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          >
            <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

            <el-table-column prop="diningPlace" label="陪餐地点"  align="center">>
            </el-table-column>

            <el-table-column prop="mealTime" label="陪餐时间" width="96" align="center">>
              <!-- <template v-slot="rowData">
                {{ $Common.dateFormatDate(rowData.row.mealTime) }}
              </template> -->
            </el-table-column>

            <el-table-column
              prop="personInChargeCateringName"
              label="陪餐负责人"
              width="92" align="center">
            >
            </el-table-column>

            <el-table-column prop="dinersName" label="陪餐人" width="70" align="center">>
            </el-table-column>

            <el-table-column prop="mealTaskName" label="陪餐任务名" align="center">>
            </el-table-column>

            <el-table-column
              prop="accompanyingMealPhotos"
              label="陪餐照片"
              width="120" align="center">
            >
              <template v-slot="scope">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="showImg(scope.row.accompanyingMealPhotos)[0]"
                  :preview-src-list="showImg(scope.row.accompanyingMealPhotos)"
                  :fit="'contain'"
                >
                </el-image>
              </template>
            </el-table-column>

            <el-table-column
              prop="whetherReportTheProblem"
              label="陪餐是否有问题"
              width="120" align="center">
            >
              <template v-slot="scope">
                <div v-if="scope.row.whetherReportTheProblem == 0">否</div>
                <div v-if="scope.row.whetherReportTheProblem == 1">是</div>
              </template>
            </el-table-column>
            <el-table-column prop="accompanyingMealRecord" label="陪餐备注" align="center">>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="requestData.pageNum"
            :page-size="requestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="responseData.total"
          >
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import AccompanyingMealManagement from "@/components/AccompanyingMealManagement";
export default {
  name: "",
  components: { AccompanyingMealManagement },
  props: {},
  data() {
    return {
      editBox: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        diners: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        mealTaskName: ""
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },
      selectedDataList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchData() {
      this.requestData.pageNum = 1;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    showImg(str) {
      let arrTemp = str.split(",");
      let arr = arrTemp.map((element) => {
        return this.$store.state.config.fileUrl + element;
      });
      return arr;
    },
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getMealAccompanyingRecords(
        this.requestData,
        true
      );
      if (res.code == 200) {
        this.responseData = res.data;
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped></style>
